<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="entity && formService.formCreated">
  <div class="container-fluid-0px">
    <div class="row">
      <div class="col-12 ps-4">
        <h5 class="my-3" i18n="@@InfomationStatusHeader">
          Systeminformationen
        </h5>
      </div>
    </div>

    <div class="row">
          <div class="col-12 ps-4" i18n="@@lastTransactionOfChargingStation"><h6 class="fw-bold">Letzter Ladevorgang</h6></div>
          <div class="col-12" *ngIf="this.lastTransactions.length > 0">
              <div class="row">
                <ng-container *ngFor="let transaction of this.lastTransactions">
                  <div class="col-12 col-lg-6">
                    <dl class="row p-3">
                      <dt *ngIf="transaction.transactionId" class="col-4" i18n="@@LastTransactionStartDate">Transaktion ID:</dt>
                      <dd *ngIf="transaction.transactionId" class="col-8">{{ transaction.transactionId }} </dd>
                      <dt *ngIf="transaction.connectorId" class="col-4" i18n="@@LastTransactionStartDate">Connector ID:</dt>
                      <dd *ngIf="transaction.connectorId" class="col-8">{{ transaction.connectorId }} </dd>
                      <dt *ngIf="transaction.startTimestamp" class="col-4" i18n="@@LastTransactionStartDate">Startdatum:</dt>
                      <dd *ngIf="transaction.startTimestamp" class="col-8">{{ transaction.startTimestamp | dateDE }} </dd>
                      <dt *ngIf="transaction.stopTimestamp" class="col-4" i18n="@@LastTransactionEndDate">Enddatum:</dt>
                      <dd *ngIf="transaction.stopTimestamp" class="col-8">{{ transaction.stopTimestamp | dateDE }} </dd>
                      <dt *ngIf="transaction.duration" class="col-4" i18n="@@LastTransactionDuration">Dauer</dt>
                      <dd *ngIf="transaction.duration" class="col-8">{{ transaction.duration}}</dd>
                      <dt *ngIf="transaction.meterAmount" class="col-4" i18n="@@LastTransactionAmount">geladene kWh</dt>
                      <dd *ngIf="transaction.meterAmount" class="col-8">{{ transaction.meterAmount | kwh }}</dd>
                      <dt *ngIf="transaction.reason" class="col-4" i18n="@@LastTransactionStatus">Status</dt>
                      <dd *ngIf="transaction.reason" class="col-8">{{ transaction.reason }}</dd>
                    </dl>
                  </div>
                </ng-container>

              </div>
          </div>
          <div class="col-12" *ngIf="this.lastTransactions.length == 0">
            Es konnte kein Ladevorgang abgerufen werden.
          </div>
    </div>

    <div class="row" *ngIf="this.entity.profile?.isUpdatable">
      <div class="col-12 ps-4">
        <h5 class="my-3" i18n="@@InfomationStatusHeader">
          Firmware
        </h5>
      </div>
    </div>
    
    <div class="row" *ngIf="this.entity.profile?.isUpdatable">
      <div class="col-12 ps-4">
        <div class="container g-1">
          <div class="row g-2 pb-2">
            <div class="col-12 col-md-4 col-lg-4 col-xl-3 ps-0 mb-2" i18n="@@FirmWareVersion">Version:</div>
            <div class="col-12 col-md-8 col-lg-8 col-xl-9 ps-0" i18n="@@CannotGetFirmWareVersionMessage">{{ !this.entity.firmware ? 'konnte nicht ermittelt werden' : this.entity.firmware }}</div>
          </div>
          <div class="row g-2 pb-2 mb-2">
            <div class="col-12 col-md-4 col-lg-4 col-xl-3 ps-0" i18n="@@FirmwareUpdate">Update/Upgrade:</div>
            <div class="col-12 col-md-8 col-lg-8 col-xl-9 ps-0 m-0">
              <div class="container">
                <div class="row">
                  <div class="col-12 input-group ps-0 ms-0">
                    <select class="form-select " id="firmware" #firmware (change)="selectFirmware(firmware.value)">
                      <option selected="selected" value="">Bitte wählen...</option>
                      <option *ngFor="let firmwareFile of this.firmwareFiles; let i = index" [ngValue]="nr">
                        {{ firmwareFile }}
                      </option>
                    </select>
                    <button type="button" id="sendFirmware" class="btn btn-primary" i18n="@@SendButton"
                            [disabled]="!configurable" (click)="startFirmwareUpdate()">
                      Aktualisieren
                    </button>
                  </div>
                </div>
                <div *ngIf="this.isUpdating" class="row">
                  <div class="col-12 mt-3 ps-0" [ngStyle]=" {'display':this.isUpdating ? 'inline' : 'none' }">
                    <div class="card alert-info rounded rounded-2 shadow-sm">
                      <div class="card-header mb-0 pb-0 text-start">Letzte Aktualisierung: {{ this.firmwareStatus.lastModified | date: 'dd.MM.yyyy HH:mm':'+0200':'de' }}</div>
                      <div class="card-body pt-2 mt-0">
                        <div *ngIf="!this.firmwareStatus.finished">Bei einem Firmware-Update wird die Ladestation mehrmals neugestartet.<br />Dabei ändert sich Ihr Status auf "nicht verfügbar" und/oder "offline". <br /></div>Status der Aktualisierung:<br />
                        <div *ngIf="this.firmwareStatus.downloading && !this.firmwareStatus.finished">
                          herunterladen...&nbsp;<span *ngIf="this.firmwareStatus.downloadFailed && !this.firmwareStatus.finished">Fehlgeschlagen!</span><span *ngIf="this.firmwareStatus.downloaded && !this.firmwareStatus.finished">fertig.</span><span *ngIf="!this.firmwareStatus.downloaded && !this.firmwareStatus.finished" class="ps-3">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <style>
                                .spinner_Wezc {
                                  transform-origin: center;
                                  animation: spinner_Oiah .75s step-end infinite
                                }

                                @keyframes spinner_Oiah {
                                  8.3% {
                                    transform: rotate(30deg)
                                  }

                                  16.6% {
                                    transform: rotate(60deg)
                                  }

                                  25% {
                                    transform: rotate(90deg)
                                  }

                                  33.3% {
                                    transform: rotate(120deg)
                                  }

                                  41.6% {
                                    transform: rotate(150deg)
                                  }

                                  50% {
                                    transform: rotate(180deg)
                                  }

                                  58.3% {
                                    transform: rotate(210deg)
                                  }

                                  66.6% {
                                    transform: rotate(240deg)
                                  }

                                  75% {
                                    transform: rotate(270deg)
                                  }

                                  83.3% {
                                    transform: rotate(300deg)
                                  }

                                  91.6% {
                                    transform: rotate(330deg)
                                  }

                                  100% {
                                    transform: rotate(360deg)
                                  }
                                }
                              </style>
                              <g class="spinner_Wezc"><circle cx="12" cy="2.5" r="1.5" opacity=".14" /><circle cx="16.75" cy="3.77" r="1.5" opacity=".29" /><circle cx="20.23" cy="7.25" r="1.5" opacity=".43" /><circle cx="21.50" cy="12.00" r="1.5" opacity=".57" /><circle cx="20.23" cy="16.75" r="1.5" opacity=".71" /><circle cx="16.75" cy="20.23" r="1.5" opacity=".86" /><circle cx="12" cy="21.5" r="1.5" /></g>
                            </svg>
                          </span>
                        </div>
                        <div *ngIf="this.firmwareStatus.installing && (!this.firmwareStatus.finished  || !this.firmwareStatus.installationFailed)">
                          installiere...&nbsp;<span *ngIf="this.firmwareStatus.finished">fertig.</span><span *ngIf="!this.firmwareStatus.finished" class="ps-3">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <style>
                                .spinner_Wezc {
                                  transform-origin: center;
                                  animation: spinner_Oiah .75s step-end infinite
                                }

                                @keyframes spinner_Oiah {
                                  8.3% {
                                    transform: rotate(30deg)
                                  }

                                  16.6% {
                                    transform: rotate(60deg)
                                  }

                                  25% {
                                    transform: rotate(90deg)
                                  }

                                  33.3% {
                                    transform: rotate(120deg)
                                  }

                                  41.6% {
                                    transform: rotate(150deg)
                                  }

                                  50% {
                                    transform: rotate(180deg)
                                  }

                                  58.3% {
                                    transform: rotate(210deg)
                                  }

                                  66.6% {
                                    transform: rotate(240deg)
                                  }

                                  75% {
                                    transform: rotate(270deg)
                                  }

                                  83.3% {
                                    transform: rotate(300deg)
                                  }

                                  91.6% {
                                    transform: rotate(330deg)
                                  }

                                  100% {
                                    transform: rotate(360deg)
                                  }
                                }
                              </style>
                              <g class="spinner_Wezc"><circle cx="12" cy="2.5" r="1.5" opacity=".14" /><circle cx="16.75" cy="3.77" r="1.5" opacity=".29" /><circle cx="20.23" cy="7.25" r="1.5" opacity=".43" /><circle cx="21.50" cy="12.00" r="1.5" opacity=".57" /><circle cx="20.23" cy="16.75" r="1.5" opacity=".71" /><circle cx="16.75" cy="20.23" r="1.5" opacity=".86" /><circle cx="12" cy="21.5" r="1.5" /></g>
                            </svg>
                          </span>
                        </div>
                        <div *ngIf="this.firmwareStatus.downloadFailed" class="alert-danger">Firmware konnte nicht heruntergeladen werden. Bitte prüfen Sie die Verbindung.</div>
                        <div *ngIf="this.firmwareStatus.installationFailed" class="alert-danger rounded-end rounded-2">Installation fehlgeschlagen. Bitte schauen Sie in den Log-Dateien der Ladestation für weitere Informationen.</div>
                        <div *ngIf="this.firmwareStatus.finished" class="fw-bold">Die Ladestation hat den Firmwarestand: {{this.entity.firmware}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 ps-4">
        <h5 class="my-3" i18n="@@SystemConfigurationHeader">
          Systemkonfiguration über OCPP
        </h5>
      </div>
    </div>
    
    <div class="row" *ngIf="formService.formCreated">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="container g-1">
          <form class="g-2 pb-2 mb-2 border-bottom" [formGroup]="formService.form">
            <div class="form-group container">
              <div class="row mb-2">
                <div class="col-12 input-group">
                    <select class="form-select col-4 col-md-2 col-lg-2 col-xl-1 getset" id="command" formControlName="command" (change)="onCommandChange()">
                      <option selected>Methode...</option>
                      <option value="GET">GET</option>
                      <option value="SET">SET</option>
                    </select>
                    <input id="keyInput" type="text" class="form-control col-auto" placeholder="Key" formControlName="keyInput" ngbTooltip="Bei mehreren Eingaben bitte mit Semikolon(;) trennen" i18n-ngbTooltip="@@CommaSeparateTooltipText" style="height: auto;">
                    <input *ngIf="command == 'SET'" id="valueInput" type="text" class="form-control col-auto" placeholder="Value" formControlName="valueInput" ngbTooltip="Bei mehreren Eingaben bitte mit mit Semikolon(;) trennen" i18n-ngbTooltip="@@CommaSeparateTooltipText" style="height: auto;">
                    <button type="submit" id="send" class="btn btn-primary col-auto" i18n="@@SendButton"
                            [disabled]="!configurable" (click)="onSubmit(formService.form.value)">
                      Senden
                    </button>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label i18n="@@ResponseLabel">Antwort:</label>
                  <textarea id="response" formControlName="response" class="form-control"
                    i18n-placeholder="@@ResponsePlaceholder" placeholder="Antwort..."></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</form>
